export default "__VITE_PUBLIC_ASSET__ade68d84__"